export default __webpack_public_path__ + "static/media/news25.7486c644.jpg";